import {useNavigate} from 'react-router-dom';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';

const ExceptionPage = props => {
  const email = config().supportEmail;
  return (
    <Container maxWidth='xs'>
      <Stack spacing={3} padding={3}>
        <Typography variant='h1'>
          Something Went Wrong
        </Typography>
        <Typography variant='body'>
          Please click the button below to return home. If this error continues,
          please contact <a href={`mailto:${email}`}>{email}</a>.
        </Typography>
        <Button
          variant='contained'
          onClick={() => window.location.replace('/')}
        >
          Return Home
        </Button>
      </Stack>
    </Container>
  );
};

export default ExceptionPage;
